"use client";

import { useMonarchTestResult } from "@/monarch/useMonarchTestResult";
import type { DegreeDetailRedesignTestResult } from "@/monarch/rules/degreeDetailRedesignTrafficV5_2/types";

import Accreditation from "./Accreditation";
import DegreeLearnerTestimonials from "./DegreeLearnerTestimonials";
import DegreeStats from "./DegreeStats";
import { mergeDegreeDetailV5_2WithMonarch } from "./degreeDetailV5_2MonarchMerge";
import {
  getDegreeDetailV5_2Defaults,
  isMaryvilleV5_2Defaults,
  localizeMaryvilleV5_2Chrome,
} from "./DegreeLearnerTestimonials/utils/learnerTestimonialsDefaultsMapping";
import useTranslations from "@/i18n/useTranslations";

export const DegreeV5_2: React.FC<{ uuid: string }> = ({ uuid }) => {
  const t = useTranslations("Program");
  const defaults = getDegreeDetailV5_2Defaults(uuid);
  const staticData =
    defaults && isMaryvilleV5_2Defaults(defaults)
      ? localizeMaryvilleV5_2Chrome(defaults, t)
      : defaults;

  const monarchResult = useMonarchTestResult<DegreeDetailRedesignTestResult>(
    "useDegreeDetailRedesignTrafficV5_2",
  );

  const rawMonarchData = monarchResult.data;
  const hasMonarchPayload =
    !monarchResult.isLoading &&
    rawMonarchData &&
    typeof rawMonarchData === "object" &&
    Object.keys(rawMonarchData).length > 0;

  if (!staticData) {
    return null;
  }

  const merged = hasMonarchPayload
    ? mergeDegreeDetailV5_2WithMonarch(
        staticData,
        rawMonarchData as DegreeDetailRedesignTestResult["data"],
      )
    : staticData;

  const {
    learnerTestimonials,
    stats,
    statsSectionTitle,
    accreditation,
    showAccreditationSection,
  } = merged;

  return (
    <>
      <DegreeLearnerTestimonials learnerTestimonials={learnerTestimonials} />

      <Accreditation
        trackEvents={true}
        degreeDetailAccreditation={{
          title: accreditation.title,
          description: accreditation.description,
          image: accreditation.image,
          showAccreditationSection,
        }}
      />

      <DegreeStats statsSectionTitle={statsSectionTitle} stats={stats} />
    </>
  );
};
